/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, BuilderUserContext } from '@gh/builder-shared';
import { BuilderPermissionSet } from '@gh/builder-shared-data';
import { AppRouter, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { RouteDataService, SlicedDataSource } from '@gh/core-data';
import {
  DialogService,
  NotificationService,
  WaitingService,
  yesAnswer,
  yesNoConfirmation,
} from '@gh/core-ui';
import { cursorTracker, GridDefinitionFactory, newGridPaginationCursor } from '@gh/core-ui-grid';
import { filter$, switchMap$ } from '@gh/rx/operators';
import { SmsTemplateListBusinessService } from '../../resources/sms-template-list-business.service';
import { SmsTemplateListItem } from '../../resources/sms-templates.model';

@Component({
  standalone: false,
  selector: 'gh-sms-template-list',
  templateUrl: 'sms-template-list.component.html',
})
export class SmsTemplateListComponent implements OnInit {
  dataSource: SlicedDataSource<SmsTemplateListItem>;
  gridDefinition: any;
  cursor = newGridPaginationCursor();

  constructor(private gridDefinitionFactory: GridDefinitionFactory,
              private routeData: RouteDataService,
              private dialogs: DialogService,
              private notifications: NotificationService,
              private waitings: WaitingService,
              private business: SmsTemplateListBusinessService,
              private router: AppRouter,
              private userContext: BuilderUserContext,
              private navigationService: BuilderNavigationService,
              private route: ActivatedRoute) {
    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased({}, {
      getRowId: (params) => String(params.data.id)
    });
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);
    this.gridDefinition.bind(gridLayout);

    const tracker = this.routeData.tracker().withEffects(cursorTracker(this.cursor));
    tracker.listen(this.route);
    tracker.filterChanges.subscribe(() => this.loadData());
  }

  loadData(): void {
    this.dataSource = this.business.findAllAsDataSource();
  }

  onCreate(): void {
    this.router.navigateToChild(['/setup/sms-templates/new']);
  }

  onEdit(id: ID): void {
    if (this.userContext.hasPermission(BuilderPermissionSet.Setup.SmsTemplates.EDIT_VIEW)) {
      this.router.navigateToChild([`/setup/sms-templates/${id}`]);
    }
  }

  onDelete(template: SmsTemplateListItem): void {
    this.dialogs.confirmation(yesNoConfirmation('msg_template_delete', { name: template.name })).pipe(
      filter$(yesAnswer),
      switchMap$(() => this.business.remove(template).pipe((this.waitings.operator()))))
      .subscribe(
        () => this.loadData(),
        this.notifications.processAll);
  }

  goToAel(entityId?: ID): void {
    this.navigationService.goToAel({
      entityId: entityId || void 0,
      entityType: 'SMS_TEMPLATE',
      label: 'lbl_manage_sms_templates',
    });
  }
}
